import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { IconType } from '../../../../../../../../../libs/Shared/components/icon/icon';

@Component({
  selector: 'app-style-iconography',
  templateUrl: './style-iconography.component.html',
  standalone: false,
})
export class StyleIconographyComponent {
  IconType = IconType;
  iconTypesKeys = Object.keys(IconType);

  constructor(private sanitizer: DomSanitizer) {}

  getCodeSnippet(icon: string): SafeHtml {
    return this.sanitizer
      .bypassSecurityTrustHtml(`<app-icon [type]="${icon}" [class]="'xxsmall'"></app-icon>
<app-icon [type]="${icon}" [class]="'xsmall'"></app-icon>
<app-icon [type]="${icon}" [class]="'small'"></app-icon>
<app-icon [type]="${icon}" [class]="'medium'"></app-icon>
<app-icon [type]="${icon}" [class]="'large'"></app-icon>
<app-icon [type]="${icon}" [class]="'xlarge'"></app-icon>`);
  }
}
